
import ProductsPage from '../../modules/ProductsPage/ProductsPage';

function ProductsLayout() {
  return (
    <div>
      <ProductsPage />
    </div>
  );
}

export default ProductsLayout;

